import { createStructuredSelector } from 'reselect'

import Infile from 'webmango-core/infile'
import { MangoRunConfig } from 'webmango-core/shfile'
import InfileData from 'webmango-core/infiledata'
import {
  getAll as getNodeStatuses
} from 'webmango-core/selectors/runstatus'

import {
  getAll as getRunSections
} from 'webmango-core/selectors/runsection'

import * as Config from 'webmango-core/selectors/config'
import * as Core from 'webmango-core/selectors/selectors'
import { shorthash, uniqid } from 'webmango-utils'

const deps = createStructuredSelector({
  process: Core.Process.get,
  runSections: getRunSections,
  statuses: getNodeStatuses,
  schemas: Core.Schema.getAll,
  runConfigSchema: Config.getRun,
  globalConfigSchema: Config.getGlobal,
  sample: Core.Sample.getForProcess,
  config: state => state.config,
  user: state => state.user
})

const NODE_ENV = process.env.NODE_ENV

export const create = (...args) => {
  const {
    process,
    runSections,
    statuses,
    schemas,
    runConfigSchema,
    globalConfigSchema,
    sample,
    config,
    user
  } = deps(...args)

  if (!process) return {}

  const id = `${uniqid()}${shorthash(user.email + NODE_ENV)}`
  const data = {
    id,
    process,
    statuses,
    runSections,
    schemas,
    runConfigSchema,
    globalConfigSchema,
    sample,
    config,
    nodes: process.nodes,
    runConfig: process.runConfig,
    globalConfig: process.globalConfig
  }

  const runConfig = MangoRunConfig(data)

  return {
    id,
    process,
    sample: data.sample,
    project: data.sample.project,
    runConfig: data.runConfig,
    globalConfig: data.globalConfig,
    inFile: Infile(InfileData(data)),
    shFile: runConfig.script,
    server: runConfig.server,
    config: runConfig,
    createdAt: new Date(new Date().toGMTString()).toISOString(),
    user: {
      email: user.email
    },
    runSections
  }
}



// WEBPACK FOOTER //
// ../webmango-core/lib/job.js